/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportLodgingDoorsV2MutationRequest,
  ExportLodgingDoorsV2MutationResponse,
  ExportLodgingDoorsV2400,
  ExportLodgingDoorsV2500,
} from '../types/ExportLodgingDoorsV2'

function getExportLodgingDoorsV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/places/lodging-doors/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async lodging doors export.
 * @summary Start an async lodging doors export
 * {@link /api/v1/places/lodging-doors/export/v2/}
 */
export async function exportLodgingDoorsV2(
  data: ExportLodgingDoorsV2MutationRequest,
  config: Partial<RequestConfig<ExportLodgingDoorsV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportLodgingDoorsV2MutationResponse,
    ResponseErrorConfig<ExportLodgingDoorsV2400 | ExportLodgingDoorsV2500>,
    ExportLodgingDoorsV2MutationRequest
  >({
    method: 'POST',
    url: getExportLodgingDoorsV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
